import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import config from '../../config';
import { Pipeline, PipelineStatus, Ged } from './types';
import { RootState } from '../store';


export const processingApi = createApi({
  reducerPath: 'processing',
  baseQuery: fetchBaseQuery({
    baseUrl: config.processingBackend,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).usertoken.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['processing', 'runState'],
  endpoints: builder => ({
    getPipelines: builder.query<Pipeline[], void>({
      query: () => ('/pipelines'),
    }),
    getPipelineRunState: builder.query<PipelineStatus, string>({
      query: ( pid ) => (`/pipelines/${pid}`),
      providesTags: ['runState'],
      keepUnusedDataFor: 0,
    }),
    runPipeline: builder.mutation<undefined, { pid: string; pipeline: Pipeline }>({
      async queryFn(arg, queryApi, extraOptions, baseQuery) {
        const createResponse = await baseQuery({ url: `/pipelines/${arg.pid}`, method: 'PUT', body: arg.pipeline });
        
        if(createResponse.error) {
          return {error: createResponse.error}
        }
        else {
          const runResponse = await baseQuery({ url: `/pipelines/${arg.pid}`, method: 'POST' })
          if(runResponse.error) return {error: runResponse.error}
          else {return {data: undefined}}
        }
      },
    }),
    deletePipeline: builder.mutation<undefined, string>({
      query: ( pid ) => ({ url: `/pipelines/${pid}`, method: 'DELETE' }),
      invalidatesTags: ['runState'],
    }),
    evalPipeline: builder.mutation<any, { pid: string | undefined; ref_pid: string | undefined }>({
      async queryFn(arg, queryApi, extraOptions, baseQuery) {
        const evalResponse = await baseQuery({ url: `/pipelines/${arg.pid}/${arg.ref_pid}`, method: 'PUT' });
        
        if(evalResponse.error) {
          return {error: evalResponse.error}
        }
        else {
          return {data: evalResponse.data}
        }
      },
    }),
    submitPipeline: builder.mutation<any, { assignment_title: string | undefined; pid: string | undefined }>({
      async queryFn(arg, queryApi, extraOptions, baseQuery) {
        const evalResponse = await baseQuery({ url: `/submit/${arg.assignment_title}/${arg.pid}`, method: 'PUT' });
        
        if(evalResponse.error) {
          return {error: evalResponse.error}
        }
        else {
          return {data: evalResponse.data}
        }
      },
    }),
  }),
});


export const {useSubmitPipelineMutation, useEvalPipelineMutation, useGetPipelinesQuery, useRunPipelineMutation, useDeletePipelineMutation, useGetPipelineRunStateQuery } = processingApi;